import '../css/theme.css';
import "../css/bootstrap@3.3.7.min.css";

$('header').load('./ajax/header.html');
$('footer').load('./ajax/footer.html');